export default "__VITE_ASSET__B1qtwab7__"